declare namespace $ {

	type $mol_number__value_min_shm_echarts_settings_1 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['value_min'] >
	>
	type $mol_number__precision_change_shm_echarts_settings_2 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision_change'] >
	>
	type $mol_number__value_shm_echarts_settings_3 = $mol_type_enforce<
		ReturnType< $shm_echarts_settings['animation_duration_initial'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__event_shm_echarts_settings_4 = $mol_type_enforce<
		({ 
			focusout( next?: ReturnType< $shm_echarts_settings['animation_duration_initial_save'] > ): ReturnType< $shm_echarts_settings['animation_duration_initial_save'] >,
		})  & ReturnType< $mol_number['event'] >
		,
		ReturnType< $mol_number['event'] >
	>
	type $mol_labeler__title_shm_echarts_settings_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_echarts_settings_6 = $mol_type_enforce<
		ReturnType< $shm_echarts_settings['Animation_duration_initial'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_number__value_min_shm_echarts_settings_7 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['value_min'] >
	>
	type $mol_number__precision_change_shm_echarts_settings_8 = $mol_type_enforce<
		number
		,
		ReturnType< $mol_number['precision_change'] >
	>
	type $mol_number__value_shm_echarts_settings_9 = $mol_type_enforce<
		ReturnType< $shm_echarts_settings['animation_duration_update'] >
		,
		ReturnType< $mol_number['value'] >
	>
	type $mol_number__event_shm_echarts_settings_10 = $mol_type_enforce<
		({ 
			focusout( next?: ReturnType< $shm_echarts_settings['animation_duration_update_save'] > ): ReturnType< $shm_echarts_settings['animation_duration_update_save'] >,
		})  & ReturnType< $mol_number['event'] >
		,
		ReturnType< $mol_number['event'] >
	>
	type $mol_labeler__title_shm_echarts_settings_11 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_echarts_settings_12 = $mol_type_enforce<
		ReturnType< $shm_echarts_settings['Animation_duration_update'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_select__value_shm_echarts_settings_13 = $mol_type_enforce<
		ReturnType< $shm_echarts_settings['animation_easing'] >
		,
		ReturnType< $mol_select['value'] >
	>
	type $mol_select__dictionary_shm_echarts_settings_14 = $mol_type_enforce<
		ReturnType< $shm_echarts_settings['animation_easing_options'] >
		,
		ReturnType< $mol_select['dictionary'] >
	>
	type $mol_labeler__title_shm_echarts_settings_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_echarts_settings_16 = $mol_type_enforce<
		ReturnType< $shm_echarts_settings['Animation_easing'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	export class $shm_echarts_settings extends $mol_view {
		animation_duration_initial_save( next?: any ): any
		Animation_duration_initial( ): $mol_number
		Animation_duration_initial_label( ): $mol_labeler
		animation_duration_update_save( next?: any ): any
		Animation_duration_update( ): $mol_number
		Animation_duration_update_label( ): $mol_labeler
		animation_easing( next?: string ): string
		animation_easing_options( ): ({ 
			'cubicInOut': string,
			'cubicOut': string,
			'cubicIn': string,
			'linear': string,
		}) 
		Animation_easing( ): $mol_select
		Animation_easing_label( ): $mol_labeler
		animation_duration_initial( next?: number ): number
		animation_duration_update( next?: number ): number
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=settings.view.tree.d.ts.map